export enum VehicleHealthItem {
  STANDARD_SCOPE = "standard_scope",
  ENGINE_OIL = "engine_oil",
  SPARK_PLUGS = "spark_plugs",
  AIR_FILTER_ELEMENT = "air_filter_element",
  FRONT_BRAKE = "front_brake",
  REAR_BRAKE = "rear_brake",
  BRAKE_FLUID = "brake_fluid",
  MICROFILTER = "microfilter",
  RECIRCULATION_FILTER = "recirculation_filter",
  FUEL_FILTER = "fuel_filter",
  STATUTORY_VEHICLE_INSPECTION = "statutory_vehicle_inspection",
  VEHICLE_CHECK = "vehicle_check",
}

export class VehicleHealthDataDomain {
  vehicleId: string;
  timestamp: Date;
  locationName: string;
  totalDistance: number | null;
  overdue: VehicleHealthItem[] | null;
  due: VehicleHealthItem[] | null;
  createdAt: Date | null;
  updatedAt: Date | null;

  constructor(
    vehicleId: string,
    timestamp: Date,
    locationName: string,
    totalDistance: number | null,
    overdue: VehicleHealthItem[] | null,
    due: VehicleHealthItem[] | null,
    createdAt: Date | null,
    updatedAt: Date | null
  ) {
    this.vehicleId = vehicleId;
    this.timestamp = timestamp;
    this.locationName = locationName;
    this.totalDistance = totalDistance;
    this.overdue = overdue;
    this.due = due;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }
}
